import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {lastValueFrom, retry, throwError, timer} from 'rxjs';
import {EnvironmentService} from '../EnvironmentService';
import {app} from '@microsoft/teams-js';

@Injectable({
    providedIn: 'root'
})
export class LearnerRessource {
    // The Teams tab can open before the bot has created the learner, so a missing learner gets a few more chances.
    private static readonly learnerMissingRetryCount = 10;
    private static readonly learnerMissingRetryDelayInMs = 500;

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    }

    public async getLearnerLanguage(msteamsId: string, context: app.Context): Promise<{ language: string; }> {
        return lastValueFrom(this.http.post<{ language: string; }>(`${this.environmentService.environment.serverUrl}/api/profile/language?msteamsid=${msteamsId}`, context));
    }

    public async getLearnerOrganization(msteamsId: string, context: app.Context): Promise<{ organizationId: string | undefined; }> {
        return lastValueFrom(this.http.post<{ organizationId: string; }>(`${this.environmentService.environment.serverUrl}/api/profile/organization?msteamsid=${msteamsId}`, context).pipe(
            retry({
                count: LearnerRessource.learnerMissingRetryCount,
                delay: (error: unknown) => LearnerRessource.isLearnerMissing(error) ? timer(LearnerRessource.learnerMissingRetryDelayInMs) : throwError(() => error)
            })
        ));
    }

    public static isLearnerMissing(error: unknown): boolean {
        return error instanceof HttpErrorResponse && error.status === HttpStatusCode.NotFound;
    }
}

